import React, { useContext } from 'react'
import { IconHelp } from 'mage-deps/@klarna/bubble-ui'
import { hooks as i18nHooks } from 'mage-i18n'
import { useEducationAnalytics } from 'education-tools'
import HelpContext from './HelpContext'
import ResponsiveMenuButton from '../Header/ResponsiveMenuButton'

export default function QuestionMarkButton() {
  const { isOpen, setIsOpen } = useContext(HelpContext)
  const t = i18nHooks.useTranslator()
  const track = useEducationAnalytics({ category: 'uhqm/help-button', action: 'click' })

  return (
    <ResponsiveMenuButton
      id="helpful-question-mark-button"
      toggled={isOpen}
      label={t('core.helpful-question-mark.helpLabel')}
      Icon={IconHelp}
      isBorderless
      onClick={() => {
        if (isOpen) {
          track({ label: 'close' })
          setIsOpen(false)
        } else {
          track({ label: 'open' })
          setIsOpen(true)
        }
      }}
    />
  )
}
